import Banner from "../components/Banner"
import HomeHighlights from "../components/HomeHighlights";
import Partners from "../components/Partners";
const Home = ()=>{
    return <section>
        <Banner/>
        <HomeHighlights/>
        <Partners/>
    </section>
}

export default Home